// CRM 2.0 · M12 · Top sheet (DC-225): Project › Template Mapping, part "Top sheet (internal)" below the CRM 2.0
// agreement links. One row per project: this project's own Live top-sheet template, or none, in which case its
// bookings (landowner units too: they use their VJ project) get the company default (Templates › Company defaults).
// Saved through the same links call as the agreement (kind TOP_SHEET, no tower, no plan).
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import cls from "../../Pages/Templates/Templates.module.css";
import { getTemplateLinks, saveTemplateLinks } from "../../Services/Templates";
import { canDo } from "../../Pages/Templates/templateCommon";
import { errorTost, successTost } from "../../Services/Toast";

const KIND = "TOP_SHEET";
const COMPANY = ""; // the dropdown value for "no own link: the company default"

export default function Crm2TopSheetLink({ projectId }) {
  const user = useSelector((state) => state.Auth.user);
  const allowed = canDo(user, "Template Linking");
  const [data, setData] = useState(null);
  const [picked, setPicked] = useState(COMPANY);
  const [busy, setBusy] = useState(false);
  const [problem, setProblem] = useState(null);

  function show(d) {
    setData(d);
    setPicked(d.links[0] ? d.links[0].docTemplateId : COMPANY);
  }

  useEffect(() => {
    if (!projectId || !allowed) return;
    getTemplateLinks(projectId, [], KIND).then(show).catch((e) => setProblem(e.message));
  }, [projectId, allowed]);

  async function save() {
    setBusy(true);
    try {
      show(await saveTemplateLinks(projectId, picked ? [{ wingId: null, fvPaymentPlanId: null, docTemplateId: picked }] : [], [], KIND));
      successTost(picked ? "Top-sheet template linked for this project" : "This project now uses the company default top sheet");
    } catch (e) {
      errorTost(e.message);
    } finally {
      setBusy(false);
    }
  }

  const head = <h2 className={cls.panelTitle}>Top sheet (internal)</h2>;
  if (!allowed) return null; // the agreement part above already says which access is needed
  if (problem) return <div className={cls.page} style={{ padding: "1.6rem 0 0" }}><div className={cls.panel}>{head}<p className={cls.hint}>{problem}</p></div></div>;
  if (!data) return <div className={cls.page} style={{ padding: "1.6rem 0 0" }}><div className={cls.panel}>{head}<p className={cls.hint}>Loading…</p></div></div>;

  const saved = data.links[0] ? data.links[0].docTemplateId : COMPANY;
  const now = data.whoGetsWhat[0] || {};
  const notLive = data.links[0] && data.links[0].status !== "LIVE" ? data.links[0] : null;
  return (
    <div className={cls.page} style={{ padding: "1.6rem 0 0" }}>
      <div className={cls.panel}>
        {head}
        <p className={cls.hint} style={{ marginTop: 0 }}>
          The internal sheet printed with each final draft and on top of each printed copy. A template linked here wins; with none, this project's
          bookings use the company default (Templates › Company defaults). Landowner units use this project's top sheet.
        </p>
        <div style={{ display: "flex", gap: "1.2rem", alignItems: "center", flexWrap: "wrap" }}>
          <select className={cls.sel} style={{ maxWidth: "44rem" }} value={picked} onChange={(e) => setPicked(e.target.value)} aria-label="Top-sheet template">
            <option value={COMPANY}>Use the company default</option>
            {data.liveTemplates.map((t) => <option key={t.docTemplateId} value={t.docTemplateId}>{t.template}</option>)}
            {notLive && <option value={notLive.docTemplateId}>{`${notLive.template || "Template"} (${String(notLive.status || "").toLowerCase()})`}</option>}
          </select>
          {picked !== saved && <button className={cls.btn} disabled={busy} onClick={() => setPicked(saved)}>Cancel changes</button>}
          <button className={`${cls.btn} ${cls.primary}`} disabled={busy || picked === saved} onClick={save}>Save</button>
        </div>
        <p className={cls.hint} style={{ marginBottom: 0, ...(now.template ? {} : { color: "var(--err)" }) }}>
          Bookings of this project get: {now.template ? `${now.template}${now.companyDefault ? " (company default)" : ""}` : now.problem || "No top sheet"}
        </p>
      </div>
    </div>
  );
}
